BannerAdPanel = table.const(table(
    [1, "kLosePanel", "banner_levelfailed"],
    [1, "kWinPanel", "banner_levelsucceed"],
    [1, "kEnergy", "banner_energy"],
    [1, "kChestPanel", "banner_starchest"],
    [1, "kCashNotEnough", "banner_happycoin"],
    [1, "kRank", "banner_rank"],
    [1, "kPvp", "banner_pvp"],
    [1, "kShortCut", "banner_shortcut"],
    [1, "kCoinNotEnough", "banner_coin"],
    //[1, "kShortCutReward", "banner_shortcutreward"],
    [1, "kMarket", "banner_shop"],
    [1, "kRedBag", "banner_redbag"],
    [1, "kNewPvp", "banner_newpvp"],
    [1, "kNewChest", "banner_newchest"],
    [1, "kNewRank", "banner_newrank"]
))
GridAdPanel = {
    "kLosePanel": "grid_levelfailed",
    "kWinPanel": "grid_levelsucceed",
    "kEnergy": "grid_energy",
    "kChestPanel": "grid_starchest",
    "kCashNotEnough": "grid_happycoin",
    "kRank": "grid_rank",
    "kShortCut": "grid_shortcut",
    "kCoinNotEnough": "grid_coin"
}

